import {toast} from "react-toastify"
import {downloadFileFromLink} from "../misc/file-download"

const CURRENT_PAGE = "/appstate/currentPage"
const IS_NOT_FIRST_PAGE = "/appstate/isNotFirstPage"
const IS_NOT_LAST_PAGE = "/appstate/isNotLastPage"

const FIRST_PAGE = 1
const LAST_PAGE = 2

export const siSchiessplatzActions = ({
    getDataFromPointer,
    updateData,
}) => {
    return {
        OPEN_MODAL_AU: () => {
            updateData(true, "/appstate/schiessplatz/auModalOpen")
        },
        OPEN_MODAL_AV: () => {
            updateData(true, "/appstate/schiessplatz/avModalOpen")
        },
        OPEN_MODAL_HI: () => {
            updateData(true, "/appstate/schiessplatz/hiModalOpen")
        },
        OPEN_MODAL_BU: () => {
            updateData(true, "/appstate/schiessplatz/buModalOpen")
        },
        CLOSE_MODAL_BU: () => {
            updateData(false, "/appstate/schiessplatz/buModalOpen")
        },
        CLOSE_MODAL_AU: () => {
            updateData(false, "/appstate/schiessplatz/auModalOpen")
        },
        CLOSE_MODAL_AV: () => {
            updateData(false, "/appstate/schiessplatz/avModalOpen")
        },
        CLOSE_MODAL_HI: () => {
            updateData(false, "/appstate/schiessplatz/hiModalOpen")
        },
        OPEN_MODAL_EU: () => {
            updateData(true, "/appstate/schiessplatz/euModalOpen")
        },
        OPEN_MODAL_PFLEGE: () => {
            updateData(true, "/appstate/schiessplatz/pflegeModalOpen")
        },
        CLOSE_MODAL_EU: () => {
            updateData(false, "/appstate/schiessplatz/euModalOpen")
        },
        CLOSE_MODAL_PFLEGE: () => {
            updateData(false, "/appstate/schiessplatz/pflegeModalOpen")
        },
        CLOSE_MODAL_GEHALT: () => {
            updateData(false, "/appstate/schiessplatz/gehaltModalOpen")
        },
        OPEN_MODAL_GEHALT: () => {
            updateData(true, "/appstate/schiessplatz/gehaltModalOpen")
        },
        SI_WEITER: () => {
            const currentPage = getDataFromPointer(CURRENT_PAGE)
            const nextPage = +currentPage + 1
            updateData(nextPage, CURRENT_PAGE)
            updateData(nextPage > FIRST_PAGE, IS_NOT_FIRST_PAGE)
            updateData(nextPage < LAST_PAGE, IS_NOT_LAST_PAGE)
        },
        SI_ZURUECK: () => {
            const currentPage = getDataFromPointer(CURRENT_PAGE)
            const nextPage = +currentPage - 1
            updateData(nextPage, CURRENT_PAGE)
            updateData(nextPage > FIRST_PAGE, IS_NOT_FIRST_PAGE)
            updateData(nextPage < LAST_PAGE, IS_NOT_LAST_PAGE)
        },
        SET_PAGE: (payload) => {
            if (payload === FIRST_PAGE) {
                updateData(payload, CURRENT_PAGE)
                updateData(true, IS_NOT_LAST_PAGE)
                updateData(false, IS_NOT_FIRST_PAGE)
            } else if (payload === LAST_PAGE) {
                updateData(payload, CURRENT_PAGE)
                updateData(false, IS_NOT_LAST_PAGE)
                updateData(true, IS_NOT_FIRST_PAGE)
            } else {
                updateData(true, IS_NOT_LAST_PAGE)
                updateData(true, IS_NOT_FIRST_PAGE)
                updateData(payload, CURRENT_PAGE)
            }
        },
        PRINT: async () => {
            const druckJson = {
                kundeNp: {
                    modelId: "CFsg6IJoEH_vKY_s",
                    vorname: "Max",
                    nachname: "Musterman",
                    titel: "string",
                    geburtsdatum: natPersData.geburtsdatum,
                    monatlichesBruttoEinkommen: natPersData.monatlichesBruttoEinkommen,
                    beruflicherStatus: natPersData.beruflicherStatus,
                    familienstand: natPersData.familienstand,
                    kapitalanlagenList: [],
                },
                berechnungsvorgabenHinterbliebene: {
                    versorgungszielArt: "EURO_MONATLICH",
                    versorgungszielProzent: 0.1,
                },
                berechnungsvorgabenAltersvorsorge: {
                    versorgungszielArt: "EURO_MONATLICH",
                    versorgungszielProzent: 0.1,
                },
                berechnungsvorgabenPflege: {
                    versorgungszielArt: "EURO_MONATLICH",
                    versorgungszielProzent: 0.1,
                },
                berechnungsvorgabenArbeitssicherungOhneErwerbsminderung: {
                    versorgungszielArt: "EURO_MONATLICH",
                    versorgungszielProzent: 0.1,
                },
                berechnungsvorgabenArbeitssicherungVolleErwerbsminderung: {
                    versorgungszielArt: "EURO_MONATLICH",
                    versorgungszielProzent: 0.1,
                },
                berechnungsvorgabenArbeitssicherungHalbeErwerbsminderung: {
                    versorgungszielArt: "EURO_MONATLICH",
                    versorgungszielProzent: 0.1,
                },
                berechnungsvorgabenKrankentagegeld: {
                    versorgungszielArt: "EURO_MONATLICH",
                    versorgungszielProzent: 0.1,
                },
                berechnungsvorgabenVermoegen: {
                    versorgungsziel: 100,
                    aktuellesVermoegen: 0.1,
                    laufzeit: 1073741824,
                    zinssatz: 0.1,
                    invest: 0.1,
                },
                berechnungsvorgabenEigenheim: {
                    versorgungsziel: 100,
                    aktuellesVermoegen: 0.1,
                    laufzeit: 1073741824,
                    zinssatz: 0.1,
                    invest: 0.1,
                },
            }

            await downloadFileFromLink(
                {...getDataFromPointer("/links/printAngebot"), methods: ["POST"]},
                "Druckstück",
                druckJson,
            )
        },
    }
}
